import React from "react"
import { useConsultantDetailsContext } from "../ConsultantDetails"
import MyCard from "@common-utils/MyCard"

const ConsultantDetailsCompte = () => {
     const { detailsQuery } = useConsultantDetailsContext()
     const consultant = detailsQuery.data?.consultant!
     const user = consultant.candidat?.user!

     return (
          <>
               <MyCard>
                    <MyCard.Header>
                         <div className={"d-flex align-items-center"}>Compte</div>
                    </MyCard.Header>
                    <MyCard.Body>
                         <div className="row">
                              <label className="col-lg-4 fw-bold text-muted">Dernière connexion</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">
                                        {user.dateDerniereConnexion ? user.dateDerniereConnexion?.format("dddd D MMMM YYYY à HH[h]mmm") : "Jamais connecté"}
                                   </span>
                              </div>
                         </div>
                    </MyCard.Body>
               </MyCard>
          </>
     )
}

export default ConsultantDetailsCompte
